"use strict";

var PyDefUtils = require("PyDefUtils");

module.exports = function(pyModule) {

	pyModule["DesignHtmlPanel"] = Sk.misceval.buildClass(pyModule, function($gbl, $loc) {

        var properties = PyDefUtils.assembleGroupProperties([]);

        $loc["__init__"] = new Sk.builtin.func(PyDefUtils.withRawKwargs(function(kwargs, self) {
            self._anvil.whereWillItLand = function(x, y, width, height, mouseX, mouseY) {
                // TODO: When this function call gets a bit more metadata
                // (what are its existing layout properties; am I its current container?)
                // then we can intelligently remove unused slot tags, and preserve the slot
                // names of components that get dragged around


                // We start out by finding the next available slot number
                var htmlText = self._anvil.getPropJS("html"), jq = $("<div>"+htmlText);
                var isSlotTaken = function(n) {
                    if(jq.find("[anvil-slot=designer"+n+"], [anvil-slot-repeat=designer"+n+"]").length != 0)
                        return true;

                    for (var i in self._anvil.childLayoutProps) {
                        if (self._anvil.childLayoutProps[i].slot == "designer"+n)
                            return true;
                    }
                    return false;
                };
                var nextSlot = 1;
                while(isSlotTaken(nextSlot)) { nextSlot++; }


                // Now, let's work out where we want to insert this
                var range = document.caretRangeFromPoint(mouseX, mouseY);

                //console.log(range);

                // Is this inside one of our contained components? If so, walk up
                // and put the range on one side or the other
                var e = $(range.startContainer);
                while (true) {
                    if (e.is(self._anvil.element)) { break; }
                    if (e.is(".anvil-component, [anvil-slot], [anvil-slot-repeat]")) {
                        range = new Range();
                        if (x+width/2 >= e.offset().left + e.width()/2) {
                            range.setStartAfter(e[0]);
                            range.setEndAfter(e[0]);
                        } else {
                            range.setStartBefore(e[0]);
                            range.setEndBefore(e[0]);
                        }
                    }
                    e = e.parent();
                    if (e.length == 0) {
                        // It wasn't actually inside our contained component at all
                        range = new Range();
                        range.setStart(self._anvil.element[0], 0);
                        range.setEnd(self._anvil.element[0], 0);
                        break;
                    }
                }

                var insertPos;
                // Find a bounding rectangle that expresses nearby elements.
                // 1. If there's a neighbour to the left, use the RHS of its bounding box
                // 2. If there's a neighbour to the right, use the RHS of its bounding box
                // 3. Else use the container's height and left-hand edge
                var rc = range.cloneRange();
                if (rc.startOffset > 0) {
                    rc.setStart(rc.startContainer, rc.startOffset-1);
                    var r = rc.getBoundingClientRect();
                    insertPos = {x: r.right, y: r.top, height: r.bottom-r.top};
                } else if (rc.endOffset < rc.startContainer.childNodes.length - 1) {
                    rc.setEnd(rc.startContainer, rc.startOffset+1);
                    var r = rc.getBoundingClientRect();
                    insertPos = {x: r.left, y: r.top, height: r.bottom-r.top};
                } else {
                    rc.selectNode(rc.startContainer);
                    var r = rc.getBoundingClientRect();
                    insertPos = {x: r.left, y: r.top, height: r.bottom-r.top};
                }

                // Great. Now we just need to work out what that range is, and get an HTML
                // document reflecting the newly inserted slot. We can get a twofer here...
                var newSlot = $('<span anvil-slot="designer'+nextSlot+'"></span>');
                //console.log(newSlot.length, typeof(newSlot[0]), newSlot[0]);
                range.insertNode(newSlot[0]);

                var e = self._anvil.element.clone();
                e.find(".anvil-component").remove()
                e.find("[anvil-slot], [anvil-slot-repeat], [anvil-component-here]").removeClass("anvil-inline-container");
                e.find("[anvil-slot][class=''], [anvil-slot-repeat][class='']").removeAttr("class");
                // While we're at it, let's cull all the designer-created slots we don't have components for
                var knownSlots = {};
                knownSlots["designer"+nextSlot] = true;
                for (var i in self._anvil.childLayoutProps) {
                    knownSlots[self._anvil.childLayoutProps[i].slot] = true;
                }
                e.find("[anvil-slot]").filter(function(_, e) {
                    var slName = $(e).attr("anvil-slot");
                    return (/^designer[0-9]+$/.test(slName)) && !knownSlots[slName];
                }).remove();
                var newHtml = e.html();
                newSlot.remove();

                var otherComponentUpdates = {};
                otherComponentUpdates[self._anvil.componentSpec.name] = {properties: {html: newHtml}};

                var elt = self._anvil.element;

                if (insertPos.height < 10) {
                    insertPos.y -= (10 - insertPos.height)/2;
                    insertPos.height = 10;
                }
                insertPos.width = 0;

                return {
                    childIdx: 0,
                    layoutProperties: {slot: "designer"+nextSlot},
                    otherComponentUpdates: otherComponentUpdates,
                    estimatedPosition: insertPos,
                };
            };

            // Copied to DesignHtmlPanel and DesignHtmlTemplate (ew)
            self._anvil.setLayoutProperties = (pyChild, layoutProperties) => {
                let slot;
                if ("slot" in layoutProperties) {
                    slot = layoutProperties["slot"];
                    pyChild._anvil.element.detach();
                    if (pyChild._anvil.parent.removeFn) pyChild._anvil.parent.removeFn();
                    self._anvil.addComponentToDom(self, pyChild, slot);
                } else {
                    slot = self._anvil.childLayoutProps[pyChild._anvil.componentSpec.name].slot;
                }

                const ps = {};
                ps[pyChild._anvil.componentSpec.name] = { slot, data_binding: layoutProperties["data_binding"] };
                return ps;
            };

        }));
    }, "DesignHtmlPanel", [pyModule["HtmlPanel"]]);
};

/*
 * TO TEST:
 *
 *  - New props: html
 *  - Methods: add_component
 *  - Child layout props: slot
 *
 */
